import actionTypes from '../constants/action-types';

const fetchActiveSubscriptions = () => ({
  type: actionTypes.FETCH_ACTIVE_SUBSCRIPTIONS,
});

export default fetchActiveSubscriptions;
